import React from 'react';
import { Col, Form, Input, DatePicker } from 'antd';
import locale from 'antd/es/date-picker/locale/en_US';
import moment from 'moment';
import BackendSearchField from 'src/components/BackendSearchField/BackendSearchField';

const renderLabelAndInput = (props) : React.ReactElement => {
  const {
    colSpan,
    label,
    key,
    classes,
    rules,
    initialValue,
    placeholder,
    formStyles,
    form,
    labelStyles,
    isRequired,
    onChange,
    disabled,
    type,
  } = props;

  const renderText = () => {
    return (
      <Form.Item
        style={{ ...formStyles }}
        name={key}
        rules={rules || []}
        initialValue={initialValue}
      >
        <Input
          disabled={disabled}
          placeholder={placeholder}
          className={classes.inputField}
          onChange={onChange}
        />
      </Form.Item>
    );
  };

  const renderDatePicker = (showTime) => {
    return (
      <Form.Item
        style={{ ...formStyles }}
        name={key}
        rules={rules || []}
        getValueProps={(i) => ({ value: i ? moment(i) : undefined })}
      >
        <DatePicker
          showTime={showTime}
          locale={{
            ...locale,
            lang: {
              ...locale.lang,
              ok: 'OK',
            },
          }}
          onChange={(date) => form.setFieldsValue({ [key]: date.unix() })}
          placeholder={placeholder}
          format='YYYY-MM-DD HH:mm:ss'
        />
      </Form.Item>
    );
  };

  const renderBackendSearch = () => {
    const { formUIComponent } = props;
    return (
      <Form.Item
        style={{ ...formStyles }}
        name={key}
        rules={rules || []}
        initialValue={initialValue}
      >
        <BackendSearchField
          fieldConfig={formUIComponent}
          onChange={onChange}
          disabled={disabled}
          placeholder={placeholder}
        />
      </Form.Item>
    );
  };

  const renderInput = () => {
    switch (type) {
      case 'date':
        return renderDatePicker(false);
      case 'datetime':
        return renderDatePicker(true);
      case 'text':
        return renderText();
      case 'backend_search':
        return renderBackendSearch();
      default:
        return renderText();
    }
  };

  return (
    <>
      <Col span={colSpan?.left} className={classes.label} style={{ ...labelStyles }}>
        {label}
        {isRequired && <span style={{ color: '#E83939', fontSize: '14px' }}>*</span>}
      </Col>
      <Col span={colSpan?.right}>
        <Form form={form}>
          {renderInput()}
        </Form>
      </Col>
    </>
  );
};

export {
  renderLabelAndInput,
};
